import styled, { css } from "styled-components";
import { breakpoints } from "styles/grid";

// #####################################################

export const SelectorWrapperStyled = styled(
	({
		flex1,
		noPad,
		noTopMargin,
		noBottomMargin,
		noMinWidth,
		isOpen,
		layerSide,
		innerRef,
		noBold,
		...props
	}) => <div ref={innerRef} {...props} />
)`
	position: relative;
	display: flex;
	min-width: 200px;
	background: var(--dz-sys-input-background-color);
	border-radius: var(--dz-sys-input-border-radius);

	@media (max-width: ${breakpoints.phone - 1}px) {
		min-width: unset;
		width: 100%;
	}

	${({ flex1 }) =>
		flex1 &&
		css`
			flex: 1;
		`}

	${({ noMinWidth }) =>
		noMinWidth &&
		css`
			min-width: 0px;
		`}

	${({ noPad }) =>
		!noPad &&
		css`
			@media (min-width: ${breakpoints.tablet}px) {
				margin-right: 0.5rem;
			}
		`}

	${({ isOpen, layerSide }) =>
		isOpen &&
		css`
			@media (min-width: ${breakpoints.tablet}px) {
				${layerSide === "top"
					? css`
							border-top-left-radius: 0px;
							border-top-right-radius: 0px;
					  `
					: css`
							border-bottom-left-radius: 0px;
							border-bottom-right-radius: 0px;
					  `}
			}
		`}
`;

// #####################################################
